module.exports = __webpack_public_path__ + "static/web-apps-banner-img-tiny-ca2f03d703cb36cad367a1f8835eea25.jpg";